import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function FilePreviewDialog({
  open,
  onOpenChange,
  file,
}) {
  if (!file) return null;

  const type = file.type || "";
  const isImage = type.startsWith("image/");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl rounded-3xl">
        <DialogHeader>
          <DialogTitle className="truncate text-xl font-black">
            {file.name}
          </DialogTitle>
        </DialogHeader>

        <div className="flex max-h-[75vh] items-center justify-center overflow-auto rounded-2xl bg-slate-100 p-4">

          {isImage ? (
            <img
              src={URL.createObjectURL(file)}
              alt={file.name}
              className="max-h-[70vh] rounded-xl shadow-xl"
            />
          ) : (
            <div className="flex h-80 w-full items-center justify-center rounded-2xl border-2 border-dashed border-slate-300 bg-white text-center">
              <div>
                <div className="text-lg font-black">
                  Vista previa PDF
                </div>

                <div className="mt-2 text-sm text-slate-500">
                  En el siguiente bloque mostraremos el PDF completo
                  dentro de la aplicación.
                </div>
              </div>
            </div>
          )}

        </div>
      </DialogContent>
    </Dialog>
  );
}
